import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { SearchIngredient, TempRecipeIngredient } from '@/api/types'
import { Label } from '@/components/Label'

import IngredientsEditorItem from './IngredientsEditorItem'
import IngredientsSearch from './IngredientsSearch'

import './IngredientsEditor.css'

type Props = {
  recipeIngredients: TempRecipeIngredient[]
  language: string
  updateIngredients: (recIngredients: TempRecipeIngredient[]) => void
  isDisabled?: boolean
}

export default function IngredientsEditor({
  recipeIngredients,
  language,
  isDisabled,
  updateIngredients,
}: Props) {
  const { t } = useTranslation()
  const [ingredientQtyFocus, setIngredientQtyFocus] = useState<number | null>(null)

  const deleteRecIngredient = (idIngredient: number) => {
    const updatedArray = recipeIngredients.filter(
      (rc) => rc.ingredient.idIngredient !== idIngredient,
    )
    updateIngredients(updatedArray)
  }

  const updateRecIngredient = (recIng: TempRecipeIngredient) => {
    const updatedArray = recipeIngredients.map((rc) => {
      if (rc.ingredient.idIngredient === recIng.ingredient.idIngredient) {
        return recIng
      }

      return rc
    })
    updateIngredients(updatedArray)
  }

  const addRecIngredient = (searchIng: SearchIngredient) => {
    const newEntry: TempRecipeIngredient = {
      quantity: 0,
      ingredient: searchIng,
    }

    const updatedArray = [...recipeIngredients, newEntry]

    updateIngredients(updatedArray)
    setIngredientQtyFocus(searchIng.idIngredient)
  }

  return (
    <div className="IngredientsEditor">
      <div className="IngredientsEditor-header">
        <Label>{t('recipe.ingredients')}</Label>
        <div className="IngredientsEditor-unit">{t('recipe.unit')}</div>
        <div className="IngredientsEditor-quantity">{t('recipe.quantity')}</div>
        <div>Kcal</div>
      </div>
      {recipeIngredients.map((recipeIng) => {
        return (
          <IngredientsEditorItem
            isDisabled={isDisabled}
            key={recipeIng.ingredient.idIngredient}
            recipeIngredient={recipeIng}
            language={language}
            deleteRecIngredient={deleteRecIngredient}
            updateRecIngredient={updateRecIngredient}
            isQuantityFocused={ingredientQtyFocus === recipeIng.ingredient.idIngredient}
            onBlur={() => setIngredientQtyFocus(null)}
          />
        )
      })}

      {recipeIngredients.length === 0 && (
        <div className="IngredientsEditor-empty">{t('recipe.noIngredients')}</div>
      )}
      {!isDisabled && (
        <IngredientsSearch
          addRecIngredient={addRecIngredient}
          currentSelection={recipeIngredients}
        />
      )}
    </div>
  )
}
